// ProtectedRoute.js
import { Navigate, useLocation } from 'react-router-dom';
import { getAuth } from '../utils/auth';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { token, role } = getAuth();
    const location = useLocation();


   if (!token) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }
  // if roles not required → allow any logged user
  if (!allowedRoles) {
    return children;
  }

  // if role required but missing
  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }


  return children;
}
